import {
    CREATE_PROPERTY_FAILURE,
    CREATE_PROPERTY_REQUEST,
    CREATE_PROPERTY_SUCCESS,
    CREATE_USER_FORM_PROPERTY,
    DELETE_PROPERTY_FAILURE,
    DELETE_PROPERTY_REQUEST,
    DELETE_PROPERTY_SUCCESS,
    FETCH_DROPDOWN_PROPERTY_FAILURE,
    FETCH_DROPDOWN_PROPERTY_REQUEST,
    FETCH_DROPDOWN_PROPERTY_SUCCESS,
    FETCH_PROPERTY_FAILURE,
    FETCH_PROPERTY_REQUEST,
    FETCH_PROPERTY_SUCCESS,
    FETCH_SINGLE_PROPERTY_FAILURE,
    FETCH_SINGLE_PROPERTY_REQUEST,
    FETCH_SINGLE_PROPERTY_SUCCESS,
    MAX_PROPERTY_SLNO_FAILURE,
    MAX_PROPERTY_SLNO_REQUEST,
    MAX_PROPERTY_SLNO_SUCCESS,
    PROPERTY_USERFORM_RESET,
    UPDATE_PROPERTY_FAILURE,
    UPDATE_PROPERTY_REQUEST,
    UPDATE_PROPERTY_SUCCESS
} from './property.actionsType';

export const PROPERTY = 'property';

let initialState = {
    loading: false,
    property: [],
    userform: {},
    selectedProperty: {},
    dropdownProperty: {},
    maxSlNo: '',
    errorMessage: ''
};

export let propertyReducer = (state = initialState, action) => {
    let { type, payload, updatePayload } = action;

    switch (type) {
        case FETCH_PROPERTY_REQUEST:
        case CREATE_PROPERTY_REQUEST:
        case UPDATE_PROPERTY_REQUEST:
        case FETCH_SINGLE_PROPERTY_REQUEST:
        case DELETE_PROPERTY_REQUEST:
        case FETCH_DROPDOWN_PROPERTY_REQUEST:
        case MAX_PROPERTY_SLNO_REQUEST:
            return {
                ...state,
                loading: true
            };
        case FETCH_PROPERTY_SUCCESS:
            return {
                ...state,
                loading: false,
                property: updatePayload
            };
        case FETCH_DROPDOWN_PROPERTY_SUCCESS:
            return {
                ...state,
                loading: false,
                dropdownProperty: updatePayload.sort((a, b) =>
                    a.fldDescription.toLowerCase().trim() > b.fldDescription.toLowerCase().trim() ? 1 : -1
                )
            };
        case CREATE_PROPERTY_SUCCESS:
            return {
                ...state,
                loading: false,
                userform: {},
                selectedProperty: {}
            };
        case MAX_PROPERTY_SLNO_SUCCESS:
            return {
                ...state,
                loading: false,
                maxSlNo: updatePayload
            };
        case UPDATE_PROPERTY_SUCCESS:
            return {
                ...state,
                loading: false,
                userform: {},
                selectedProperty: {},
                dropdownProperty: {}
            };
        case FETCH_SINGLE_PROPERTY_SUCCESS:
            return {
                ...state,
                loading: false,
                selectedProperty: updatePayload,
                userform: {
                    propertySelect: updatePayload.fldFKProperty,
                    slno: updatePayload.fldSlNo,
                    description: updatePayload.fldDescription,
                    sdescription: updatePayload.fldShortName
                }
            };
        case DELETE_PROPERTY_SUCCESS:
            return {
                ...state,
                loading: false,
                userform: {},
                dropdownProperty: {}
            };
        case FETCH_PROPERTY_FAILURE:
        case CREATE_PROPERTY_FAILURE:
        case UPDATE_PROPERTY_FAILURE:
        case FETCH_SINGLE_PROPERTY_FAILURE:
        case DELETE_PROPERTY_FAILURE:
        case FETCH_DROPDOWN_PROPERTY_FAILURE:
        case MAX_PROPERTY_SLNO_FAILURE:
            return {
                ...state,
                loading: false,
                errorMessage: updatePayload
            };
        case CREATE_USER_FORM_PROPERTY:
            return {
                ...state,
                loading: false,
                userform: {
                    ...state.userform,
                    [payload.key]: payload.value
                }
            };
        case PROPERTY_USERFORM_RESET:
            return {
                ...state,
                userform: {}
            };
        default:
            return state;
    }
};
